export const getLocalResultFilters = () => {
  const result = JSON.parse(localStorage.getItem('resultFilters'))

  return typeof result === 'object' && result?.length >= 1 // Prevent null or undefined value
    ? result
    : []
}
